import script from "./Transactions.vue?vue&type=script&setup=true&lang=js"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=js"

import "./Transactions.vue?vue&type=style&index=0&id=2d09e49a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d09e49a"]])

export default __exports__